import { Nav, Navbar, NavLink } from "react-bootstrap";
//import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import MainSidebar from './MainSidebar';
import GlobalFilters from "../components/GlobalFilters";
import { clearTypeTreeCache } from "../services/typeTreeCache";

const token = localStorage.getItem("token");

const Navigationbar = () => {

  const navigate = useNavigate();

  const handleLogout = async () => {
    clearTypeTreeCache();        
    try {
      await fetch("/amz-api/account/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include", // якщо використовуєш cookie
      });
    } catch (error) {
      console.error("Logout failed:", error);
      // все одно очищаємо локально, навіть якщо сервер не відповів
    }

    localStorage.removeItem("token");
    navigate("/login");
    window.location.reload();
  };

  if(token)
    return (
        <nav className="navbar navbar-dark">
          <div className="container-fluid">
            <div className="d-flex align-items-center gap-1">
              <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
                <i className="fa-solid fa-bars"></i>
              </button>
              <GlobalFilters />
              <MainSidebar />
            </div>
            <ul className="nav justify-content-end right-menu">
              <li className="nav-item dropdown">
                <button className="btn btn-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="fa-solid fa-user"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-end">
                  <li><NavLink  to="https://profitpalms.com/account?app=true" className="dropdown-item"><i className="fa-solid fa-user"></i> Account</NavLink></li>
                  <li><hr className="dropdown-divider"/></li>
                  <li>
                    <NavLink className="dropdown-item" onClick={handleLogout}><i className="fa-solid fa-right-from-bracket"></i> Logout</NavLink>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
    )
  else
    return (
        <Navbar collapseOnSelect expand="sm" variant="dark">
          <div className="container-fluid">
            <a className="navbar-brand" href="#">
              <img src="/logo.png" alt="Logo" width="30" height="32" className="d-inline-block align-text-top me-2"/>Profitpalms Analytics</a>
          </div>
        </Navbar>
    );
}

export default Navigationbar;
